import { useState } from "react";

const AVATAR_COLORS = [
  "#1e3a5f", "#f0a500", "#059669", "#7c3aed", "#dc2626",
  "#0891b2", "#d97706", "#be185d", "#065f46", "#1d4ed8",
];

function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase();
}

interface WebAvatarProps {
  name: string;
  avatarUrl?: string | null;
  size?: number;
  className?: string;
  shape?: "circle" | "rounded";
}

export function WebAvatar({
  name,
  avatarUrl,
  size = 40,
  className = "",
  shape = "circle",
}: WebAvatarProps) {
  const [imgError, setImgError] = useState(false);
  const bg = getAvatarColor(name);
  const initials = getInitials(name);
  const fontSize = Math.max(10, Math.round(size * 0.38));
  const borderRadius = shape === "circle" ? "9999px" : "12px";

  const containerStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius,
    backgroundColor: bg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",
  };

  const initialsStyle: React.CSSProperties = {
    color: "#fff",
    fontWeight: 700,
    fontSize,
    lineHeight: 1,
  };

  if (avatarUrl && !imgError) {
    return (
      <div style={containerStyle} className={className}>
        <img
          src={avatarUrl}
          alt={name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  return (
    <div style={containerStyle} className={className}>
      <span style={initialsStyle}>{initials}</span>
    </div>
  );
}
